"use client";

import { useEffect } from "react";
import { captureFirstTouch } from "../../library/first-touch";

/** Records first-touch attribution on whichever page a visitor lands on. */
export default function FirstTouchCapture() {
  useEffect(() => {
    captureFirstTouch();
  }, []);
  return null;
}
